<template>
    <div class="customer-satisfcation mb-2">
      <div class="ratings flex py-5 px-0">
        <button
          v-for="rating in ratings"
          :key="rating.key"
          :class="buttonClass(rating)"
        >
          {{ rating.emoji }}
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import { CSAT_RATINGS } from 'shared/constants/messages';
  
  export default {
    props: {
      selectedRating: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        ratings: CSAT_RATINGS,
      };
    },
  
    methods: {
      buttonClass(rating) {
        return [
          { selected: rating.value === this.selectedRating },
          'emoji-button shadow-none outline-none mr-8',
        ];
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .emoji-button {
    font-size: 2.5rem;
    filter: grayscale(100%);
    pointer-events: none;
  
    &.selected,
    &:focus,
    &:active {
      filter: grayscale(0%);
      transform: scale(1.32);
      transition: transform 300ms;
    }
  }
  </style>
  